module.exports = __webpack_public_path__ + "static/media/empty-assignment.dd280b58.svg";